import { Stack } from "@mantine/core";
import { IconClock, IconUser } from "@tabler/icons-react";
import TravellerDrawerRow from "./TravellerDrawerRow";
import TravellerDrawerSection from "./TravellerDrawerSection";
import { formatGender, formatPolicyDateTime, getTravellerName } from "../../utils/allPolicyHelpers";

const TravellerDrawerProfile = ({ traveller }) => {
  if (!traveller) return null;
  const nominee = traveller.nominee_name
    ? `${traveller.nominee_name}${traveller.nominee_relation ? ` — ${traveller.nominee_relation}` : ""}`
    : "—";

  return (
    <Stack gap="lg">
      <TravellerDrawerSection icon={IconUser} label="Personal Information">
        <TravellerDrawerRow label="Full Name" value={getTravellerName(traveller)} />
        <TravellerDrawerRow label="Date of Birth" value={traveller.dob} />
        <TravellerDrawerRow label="Gender" value={formatGender(traveller.gender)} />
        <TravellerDrawerRow label="Nationality" value={traveller.nationality_name} />
        <TravellerDrawerRow
          label="Indian Resident"
          value={traveller.indian_resident ? "Yes" : "No"}
        />
        <TravellerDrawerRow label="Passport No." value={traveller.passport_number} />
        <TravellerDrawerRow label="Email" value={traveller.email} />
        <TravellerDrawerRow label="Phone" value={traveller.phone_number} />
        <TravellerDrawerRow label="Nominee" value={nominee} />
      </TravellerDrawerSection>

      <TravellerDrawerSection icon={IconClock} label="Timeline">
        <TravellerDrawerRow label="Created By" value={traveller.created_by_name} />
        <TravellerDrawerRow label="Created On" value={formatPolicyDateTime(traveller.created_on)} />
        <TravellerDrawerRow label="Updated On" value={formatPolicyDateTime(traveller.updated_on)} />
        <TravellerDrawerRow
          label="Payment On"
          value={formatPolicyDateTime(traveller.payment_created_on)}
        />
      </TravellerDrawerSection>
    </Stack>
  );
};

export default TravellerDrawerProfile;
